// extracted by mini-css-extract-plugin
export var development = "minimal-footer-module--development--eNl7U";
export var footer = "minimal-footer-module--footer--QYguC";